module.exports = __webpack_public_path__ + "img/maxhub.5d7b3c9b.png";